import selectUserRoleFromLogin from 'selectors/selectUserRoleFromLogin';
import { selectPinUserIsPrimary, selectUserRoleFromPin, selectUserRoleFromSalon } from 'selectors/simple';
import fromAnyToString from 'utils/converters/fromAnyToString';

const selectEffectiveUserRole = (state) => {
  // null means the user is primary in this case
  if (selectPinUserIsPrimary(state) === false) {
    return fromAnyToString(selectUserRoleFromPin(state)).trim();
  }

  const userRole = selectUserRoleFromSalon(state) || selectUserRoleFromLogin(state);
  return fromAnyToString(userRole).trim();
};

// noinspection JSUnusedGlobalSymbols
export default selectEffectiveUserRole;
